module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "btn btn-default btn-file",
    attrs: {
      "disabled": _vm.showSummary
    }
  }, [_vm._v("\n      Escolher...\n      "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": _vm.images,
      "multiple": "",
      "accept": "image/*",
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    on: {
      "change": _vm.imagesAdd
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted field-desc"
  }, [_vm._v("São aceitos apenas imagens. Ex: jpg, jpeg, png, bmp, gif")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formField.invalid),
      expression: "formField.invalid"
    }],
    staticClass: "help-block"
  }, [_vm._v("O campo deve ser preenchido corretamente")])]), _vm._v(" "), _vm._l((_vm.imageData), function(imgDatum) {
    return _c('div', {
      staticClass: "file-upload-form"
    }, [_c('img', {
      staticClass: "preview",
      attrs: {
        "src": imgDatum
      }
    })])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5981426e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentInputPreview.vue
// module id = 1402
// module chunks = 1